import Vue from 'vue'
import Vuex from 'vuex'
import util from "../util";


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    roomOrigin: "",
    userInfo: JSON.parse(util.getCookie('userInfo')),
    roomSearch: {},
    orderConfirmation: ""
  },
  mutations: {
    login(state) {
      state.userInfo = JSON.parse(util.getCookie('userInfo'))
    },
    stateChange(state, payload) {
      state[payload.k] = payload.v
    }
  },
  actions: {},
  modules: {}

})
